export default {
    skillCenter: {
        title: 'スキルセンター',
        searchPlaceholder: 'スキルを検索...',
        createSkill: 'スキルを作成',
        aiCreate: 'AI で作成',
        noSkills: 'スキルがありません',
        noSkillsDesc: '「スキルを作成」をクリックして最初のスキルを追加しましょう',
        preview: 'プレビュー',
        edit: '編集',
        aiEdit: 'AI で編集',
        delete: '削除',
        cancel: 'キャンセル',
        save: '保存',
        close: '閉じる',
        moreActions: 'その他の操作',
        official: '公式',
        custom: 'カスタム',
        enabled: '有効',
        disabled: '無効',
        enable: '有効化',
        disable: '無効化',
        version: 'バージョン',

        viewModes: {
            grid: 'グリッド表示',
            list: 'リスト表示',
        },

        pills: {
            official: '公式スキル',
            user: 'マイスキル',
        },

        dialog: {
            createTitle: 'スキルを作成',
            editTitle: 'スキルを編集',
            previewTitle: 'スキル詳細',
            name: 'スキル名',
            namePlaceholder: 'スキル名を入力（作成後は変更できません）',
            description: '説明',
            descriptionPlaceholder: '説明を入力（任意）',
            tags: 'タグ',
            tagsPlaceholder: '入力して Enter で追加',
            tagsReadonlyHint: 'タグは作成時のみ設定できます',
            editingFile: '編集中：{path}',
            binaryFileHint: 'バイナリファイルはオンライン編集できません',
            unsavedChangesTitle: '未保存の変更',
            unsavedChangesMessage: '未保存の変更があります。破棄して閉じますか？',
            discardChanges: '破棄',
            continueEditing: '編集を続ける',
        },

        workspace: {
            title: 'AI ワークスペース',
            backToList: 'スキル一覧に戻る',
            loadingTitle: '読み込み中...',
            chatUnavailableTitle: 'AI チャットは現在利用できません',
            chatUnavailableDesc: 'スキルワークスペースの初期化に失敗したか、バックエンドサービスが準備できていません。後でスキル一覧から再度アクセスしてください。',
            toolResultTitle: 'ツール実行結果',
            saving: '保存中…',
        },

        fileTree: {
            newFile: '新規ファイル',
            fileName: 'ファイル名',
            fileNamePlaceholder: '例：api.md、run.py（拡張子を含めてください）',
            fileNameInvalid: 'ファイル名に / は使用できません',
            newDirectory: '新規ディレクトリ',
            directoryName: 'ディレクトリ名',
            parentPath: '親ディレクトリ',
            rootPath: '（ルート）',
            rename: '名前を変更',
            newName: '新しい名前',
            skillMdProtectedHint: 'SKILL.md は名前変更・削除できません',
        },

        security: {
            violationsTitle: 'コンテンツセキュリティ審査に不合格しました',
            blockedHint: '以下の違反項目を修正して再度保存してください',
            ruleId: 'ルール',
        },

        messages: {
            fetchListFailed: 'スキル一覧の取得に失敗しました',
            fetchDetailFailed: 'スキル詳細の取得に失敗しました',
            fetchFileFailed: 'ファイル内容の取得に失敗しました',
            createSuccess: '作成しました',
            createFailed: '作成に失敗しました',
            nameExists: '同じ名前のスキルが既に存在します。名前を変更して再度お試しください',
            updateSuccess: '更新しました',
            updateFailed: '更新に失敗しました',
            metadataSavedFilesNotSaved: 'スキル情報は保存されましたが、一部のファイルは保存できませんでした。違反内容を確認して再度お試しください',
            deleteSuccess: '削除しました',
            deleteFailed: '削除に失敗しました',
            enableSuccess: '有効化しました',
            enableFailed: '有効化に失敗しました',
            disableSuccess: '無効化しました',
            disableFailed: '無効化に失敗しました',
            permissionDenied: 'このスキルを操作する権限がありません',
            updateFileFailed: 'ファイルの保存に失敗しました',
            createDirectorySuccess: 'ディレクトリを作成しました',
            createDirectoryFailed: 'ディレクトリの作成に失敗しました',
            createFileSuccess: 'ファイルを作成しました',
            createFileFailed: 'ファイルの作成に失敗しました',
            fileExists: '同じ名前のファイルが既に存在します',
            renameSuccess: '名前を変更しました',
            renameFailed: '名前の変更に失敗しました',
            deleteFileSuccess: 'ファイルを削除しました',
            deleteFileFailed: 'ファイルの削除に失敗しました',
            emptyFolderNotDeletable: '空のディレクトリはまだ削除できません',
            workspaceInitFailed: 'AI ワークスペースの初期化に失敗しました。チャットは一時的に利用できません。',
        },
    },
};
